function get(path) {
  if (path && path!='') {
    if (path.toLowerCase().indexOf('mp4') > -1) {
      return 'video'
    }
  
    if (path.toLowerCase().indexOf('mov') > -1) {
      return 'video'
    }
  
    if (path.toLowerCase().indexOf('mp3') > -1) {
      return 'audio'
    }
  
    if (path.toLowerCase().indexOf('ogg') > -1) {
      return 'audio'
    }
  }
  return 'image'
}

export default {
  get
}



// WEBPACK FOOTER //
// src/helper/fileType.js